import { createCompanyAddress } from '../models/companyModels';

const SUPPLIER_FACILITIES_KEY = 'supplierFacilities';
const FACILITIES_KEY = 'facilities';

/** Graph-context tenant facilities use id/name/address; normalize to table/map field names. */
const normalizeFacilityRowFromGraphContext = (row) => {
  if (!row || typeof row !== 'object') return row;
  return {
    ...row,
    facility_id: row.facility_id ?? row.id,
    facility_name: row.facility_name ?? row.name,
    street_address: row.street_address ?? row.address,
    facility_type: row.facility_type ?? row.type,
  };
};

export const normalizeNodeRowFromApi = (nodeKey, row) => {
  if (!row || typeof row !== 'object') return row;
  if (nodeKey === FACILITIES_KEY) {
    return normalizeFacilityRowFromGraphContext(row);
  }
  if (nodeKey === SUPPLIER_FACILITIES_KEY) {
    return createCompanyAddress(row).toTableRow();
  }
  return row;
};

export const serializeNodeRowForApi = (nodeKey, row) => {
  if (nodeKey !== SUPPLIER_FACILITIES_KEY || !row || typeof row !== 'object') {
    return row;
  }
  return createCompanyAddress(row).toJSON();
};

export const normalizeNodeRowsFromApi = (nodeKey, rows) => {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => normalizeNodeRowFromApi(nodeKey, row));
};

export const serializeNodeRowsForApi = (nodeKey, rows) => {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => serializeNodeRowForApi(nodeKey, row));
};
